export function increaseNavvaticCounter() {
    Object.keys(localStorage || {})
        .filter((name) => name.startsWith('demoButtonClickHops'))
        .forEach((name) => {
            const value = parseInt(localStorage.getItem(name)!, 10);
            const count = Number.isNaN(value) ? 0 : value;
            localStorage.setItem(name, (count + 1).toString());
        });
}
